<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" *ngIf="user.role == 'ROLE_ADMIN'"><a routerLink="/admin/adminDashboard/">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">Invoices</li>
    </ol>
  </nav>
  <div class="row align-items-center">
    <div class="invalid-feedback d-block shift-invalid-text" [hidden]="!errorMessage">{{errorMessage}}</div>
    <div class="col-6">
      <ul class="list-inline tab-list deskContent">
        <li class="list-inline-item">
          <a (click)="populateTabData('all','ALL'); tabChange();" [ngClass]="{'active': tabClicked === 'all'}">All</a>
        </li>
        <li class="list-inline-item"><a (click)="populateTabData('inProcess','IN_PROCESS'); tabChange();"
                                        [ngClass]="{'active': tabClicked === 'inProcess'}">Paid</a>
        </li>
        <li class="list-inline-item">
          <a (click)="populateTabData('unPaid','UNPAID');  tabChange();"
             [ngClass]="{'active': tabClicked === 'unPaid'}">New</a>
        </li>
        <li class="list-inline-item">
          <a (click)="populateTabData('orderDue','OVER_DUE'); tabChange();"
             [ngClass]="{'active': tabClicked === 'overDue'}">Overdue</a>
        </li>
        <li class="list-inline-item">
          <a (click)="populateTabData('paid','PAID'); tabChange();" [ngClass]="{'active': tabClicked === 'paid'}">Completed</a>
        </li>

      </ul>
      <select class="form-control MobileContent" id="use2r" [(ngModel)]="userDrop2"
              [ngModelOptions]="{standalone: true}" (change)="populate(userDrop2)" style="width: 140px;"
              data-value="All" required>
        <option value="ALL">All</option>
        <option value="IN_PROCESS">Paid</option>
        <option value="UNPAID">New</option>
        <option value="OVER_DUE">Over Due</option>
        <option value="PAID">Completed</option>
      </select>
    </div>
    <div class="col-6 mt-md-0 text-right float-right" *ngIf="user.role == 'ROLE_ADMIN'">
      <button [hidden]="tabClicked == 'paid' || tabClicked == 'all' " data-toggle="dropdown" aria-haspopup="true"
              aria-expanded="false" class="btn btn-outline-primary ml-2 dropdown-toggle btn-sm d-none-mobile"
              *ngIf="(checkedList?.length) && tabClicked !== 'all'">Actions
      </button>
      <a placement="bottom" ngbTooltip="Generate" class="ml-3" (click)="openPopup()" *ngIf="user.role == 'ROLE_ADMIN'">
        <svg version="1.2" baseProfile="tiny-ps" xmlns="http://www.w3.org/2000/svg" (click)="openPopupKyc()"
             viewBox="0 0 30 30" width="30" height="30">
          <defs>
            <image width="30" height="30" id="img1"
                   href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAAXNSR0IB2cksfwAAAJNQTFRFj1C/ilW6ilS7ilW7ilS7iVS61MHkup3UkmG/+/r87uj0pHvK/fz+/v7+mmzD6N/w2cjp1MHm+/n8uJnVrIjOjFi88+73/f3+ila78ev29vL59vL67+j1593x/f39t5jTmGnDwabb8u729/T59/T6/Pz90sLm9fH55Njv0sDk/fz9+ff7wKXanHDF+Pb639LriVW7934QVQAAADF0Uk5TEJ/v/7Cg////////////////////////////////////////////////////////8ErC3YkAAACUSURBVHiczdPJDsIwDEVRt68MKZghjAUKZSwz/f+vI6KwQLLDDrirJx0p8iZEQQitgChS0VUhnyL0M77H1VpdZ2NM3PjRaU1mbunc7nRt7zH6EtvBc/BQ4tE4mSTTWYq5+LjFIltmbqxEjl/DGInXGy7b7iTO9wfmI+d8OksMXFLgCuW0Msc3D7/3v1x8+kQUFR69A2f1EEVrUWipAAAAAElFTkSuQmCC"/>
            <image width="14" height="19" id="img2"
                   href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAATCAMAAACX3symAAAAAXNSR0IB2cksfwAAAVlQTFRFAAAAiVG7gE2z////////////ilW6oXXIv6bZ////////////////ilS6////oHTH/////////////////f39+fj7/////////v7+mmzE////////////i1a7i1a7jFe7jVq8////////////nXDF////i1e7jFm8i1a7jVu8////jVq8////////////jFe7jVq9jFe6jly9////////jFm8i1e7iVW6ilW7iVW6/////v3+9/X6+PX6/////////////////////fz+/////////v7+/f39////jFi7jFe7jlq8jFi8jFe8jVq8/Pz9////mWzD////7+n2i1e7////////oXbI/fz+i1e7////////nnPGi1W7ilW7ila7////+ff6/Pz8+/v8////////////////////////////ilS6////////ilW6////////////////aDl/LQAAAHN0Uk5TACkK2P/d3pg8C978/v7ilg8C/fr+/vby/70TA/T9+/r66AH3wwz99/z666j16gj99/f57+b08////fv/+fv48Png8/nk8f78o9f8+Pv73f5zOJScyG92PenwcYA7/v75rNT+/rLp18XE47D/x5703LPGj3h5TiwAAADySURBVHicRcdXU8JAFEDhq9617SqyG0NULBjB3gtr1IiBWCg2LCj2FhVF4/9/cAPj+D2cmQPwp6ExaBPWkOaW1ja17UgpZYx0dIa6wgBcaJrWrZNwxOjp7QOM9g8MDsXIMGfmSBzQTIyOjU+QSTrFp2fUzs7NLywuLa8kk3IV0FrT1jdsIehmiumAdMtJpzPouNs7TADqu3vZbCKXL+wfMAR0D4+OlWLx5DQS7Nl5qRRTLi5dtU75Skp5LW9uy45a8+7eCDw8Ptlq+bNr2S+G4b2+cbV1/L1S+RD/+1mtfqUQhFUTZUJwy4Rvv87zPN//+QVMdSv4yYN/GwAAAABJRU5ErkJggg=="/>
          </defs>
          <style>
            tspan {
              white-space: pre
            }
          </style>
          <use id="img1" href="#img1" x="0" y="0"/>
          <use id="img2" href="#img2" x="8" y="5"/>
        </svg>
      </a>
      <a placement="bottom" ngbTooltip="Create" class="ml-3">
        <svg xmlns="http://www.w3.org/2000/svg" routerLink="/admin/createInvoice" width="30" height="30"
             viewBox="0 0 30 30">
          <defs>
            <style>.a {
              fill: #8a55bb;
            }

            .b {
              fill: #fff;
            }</style>
          </defs>
          <g transform="translate(4 2.5)">
            <rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/>
            <path class="b"
                  d="M8.563.563a8,8,0,1,0,8,8A8,8,0,0,0,8.563.563Zm4.645,8.9a.388.388,0,0,1-.387.387H9.853v2.968a.388.388,0,0,1-.387.387H7.659a.388.388,0,0,1-.387-.387V9.853H4.3a.388.388,0,0,1-.387-.387V7.659A.388.388,0,0,1,4.3,7.272H7.272V4.3a.388.388,0,0,1,.387-.387H9.466a.388.388,0,0,1,.387.387V7.272h2.968a.388.388,0,0,1,.387.387Z"
                  transform="translate(2.823 3.938)"/>
          </g>
        </svg>
      </a>
      <div class="dropdown-menu dropdown-menu2  dropdown-menu-right"
           *ngIf="(checkedList?.length) && tabClicked !== 'all'">
        <a *ngIf="tabClicked === 'inProcess'" (click)="editInvoicePaymentStatus(invoice)"
           class="dropdown-item file btn shift-import">Verify</a>
        <a *ngIf="tabClicked === 'unPaid'" (click)="editInvoicePaymentProcess(invoice)"
           class="dropdown-item file btn shift-import">Pay</a>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <div class="inner-box d-none d-sm-block" [ngClass]="{'show-pagination':(!totalRecords || totalRecords<20)}"
           style="min-height:580px!important;">
        <table class="table" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
          <thead>
          <tr>
            <th [hidden]="tabClicked == 'paid' || tabClicked === 'all' ">
            </th>
            <th>Company Name</th>
            <th>Invoice Number</th>
            <th>Invoice Type</th>
            <th>Invoice Date</th>
            <th>Invoice Amount</th>
            <th>Status</th>
            <th></th>
          </tr>
          </thead>
          <tbody class="table-body-custom">
          <tr *ngFor="let i of invoice">
            <td [hidden]="tabClicked == 'paid' || tabClicked === 'all' ">
              <div class="form-checkbox" *ngIf="user.role == 'ROLE_ADMIN'">
                <input type="checkbox" id="{{i.id}}" [(ngModel)]="i.isSelected" name="list_name"
                       (change)="selectShip(i)">
                <label for="{{i.id}}"></label></div>
            </td>
            <td>{{i.companyName}}</td>
            <td><a id="modalActivateADD" (click)="showInvoiceById(i)" data-toggle="modal"
                   href="#exampleModalPreview">{{i.invoiceNum}}</a>
            </td>
            <td>{{i.invoiceType | replaceStatus}}</td>
            <td>{{i.invoiceDate}}</td>
            <td>{{i.totalAmount}}</td>
            <td>{{(i.paymentStatus == 'PAID' ? 'Paid' : (i.paymentStatus == 'UNPAID' ? 'UnPaid' : (i.paymentStatus ==
            'IN_PROCESS' ? 'Submitted' : "")))}}
            </td>
            <td><a href="{{i.invoiceFileUrl}}" target="_blank">
              <svg class="svg-icon" viewBox="0 0 20 20">
                <path fill="none"
                      d="M15.608,6.262h-2.338v0.935h2.338c0.516,0,0.934,0.418,0.934,0.935v8.879c0,0.517-0.418,0.935-0.934,0.935H4.392c-0.516,0-0.935-0.418-0.935-0.935V8.131c0-0.516,0.419-0.935,0.935-0.935h2.336V6.262H4.392c-1.032,0-1.869,0.837-1.869,1.869v8.879c0,1.031,0.837,1.869,1.869,1.869h11.216c1.031,0,1.869-0.838,1.869-1.869V8.131C17.478,7.099,16.64,6.262,15.608,6.262z M9.513,11.973c0.017,0.082,0.047,0.162,0.109,0.226c0.104,0.106,0.243,0.143,0.378,0.126c0.135,0.017,0.274-0.02,0.377-0.126c0.064-0.065,0.097-0.147,0.115-0.231l1.708-1.751c0.178-0.183,0.178-0.479,0-0.662c-0.178-0.182-0.467-0.182-0.645,0l-1.101,1.129V1.588c0-0.258-0.204-0.467-0.456-0.467c-0.252,0-0.456,0.209-0.456,0.467v9.094L8.443,9.553c-0.178-0.182-0.467-0.182-0.645,0c-0.178,0.184-0.178,0.479,0,0.662L9.513,11.973z"></path>
              </svg>
            </a></td>

          </tr>
          </tbody>
          <tfoot>
          <tr *ngIf="invoice?.length===0|| !invoice?.length">
            <td colspan="7" class="text-center">No matching records found</td>
          </tr>
          </tfoot>
        </table>
      </div>
      <div class="inner-box d-block d-sm-none">
        <table class="table tablesaw  tablesaw-stack" data-tablesaw-mode="stack">
          <thead>
          <tr>
            <th>Company Name</th>
            <th>Invoice Number</th>
            <th>Invoice Type</th>
            <th>Invoice Date</th>
            <th>Invoice Amount</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let i of invoice">
            <td><label><b class=" tablesaw-cell-label">Company Name</b></label>
              <span class="tablesaw-cell-content">{{i.companyName}}</span></td>
            <td><label><b class=" tablesaw-cell-label">Invoice Number</b></label>
              <span class="tablesaw-cell-content"><a id="modalActivateAD" (click)="showInvoiceById(i)"
                                                     data-toggle="modal"
                                                     href="#exampleModalPreview">{{i.invoiceNum}}</a></span></td>
            <td><label><b class=" tablesaw-cell-label">Invoice Type</b></label>
              <span
                class="tablesaw-cell-content">{{(i.invoiceType == 'WORK_ORDER' ? 'Work Order' : (i.invoiceType == 'SHIP_INVOICE' ? 'Ship Invoice' : (i.invoiceType == 'FULFILLMENT' ? 'Fulfillment' : (i.invoiceType | titlecase))))}}</span>
            </td>
            <td><label><b class=" tablesaw-cell-label">Invoice Date</b></label>
              <span class="tablesaw-cell-content">{{i.invoiceDate}}</span></td>
            <td><label><b class=" tablesaw-cell-label">Invoice Amount</b></label>
              <span class="tablesaw-cell-content">{{i.totalAmount}}</span></td>
            <td><label><b class=" tablesaw-cell-label">Status</b></label>
              <span
                class="tablesaw-cell-content">{{(i.paymentStatus == 'PAID' ? 'Paid' : (i.paymentStatus == 'UNPAID' ? 'UnPaid' : (i.paymentStatus == 'IN_PROCESS' ? 'Submitted' : "")))}}
              </span></td>
            <td>
              <svg class="svg-icon" viewBox="0 0 20 20">
                <path fill="none"
                      d="M15.608,6.262h-2.338v0.935h2.338c0.516,0,0.934,0.418,0.934,0.935v8.879c0,0.517-0.418,0.935-0.934,0.935H4.392c-0.516,0-0.935-0.418-0.935-0.935V8.131c0-0.516,0.419-0.935,0.935-0.935h2.336V6.262H4.392c-1.032,0-1.869,0.837-1.869,1.869v8.879c0,1.031,0.837,1.869,1.869,1.869h11.216c1.031,0,1.869-0.838,1.869-1.869V8.131C17.478,7.099,16.64,6.262,15.608,6.262z M9.513,11.973c0.017,0.082,0.047,0.162,0.109,0.226c0.104,0.106,0.243,0.143,0.378,0.126c0.135,0.017,0.274-0.02,0.377-0.126c0.064-0.065,0.097-0.147,0.115-0.231l1.708-1.751c0.178-0.183,0.178-0.479,0-0.662c-0.178-0.182-0.467-0.182-0.645,0l-1.101,1.129V1.588c0-0.258-0.204-0.467-0.456-0.467c-0.252,0-0.456,0.209-0.456,0.467v9.094L8.443,9.553c-0.178-0.182-0.467-0.182-0.645,0c-0.178,0.184-0.178,0.479,0,0.662L9.513,11.973z"></path>
              </svg>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</section>


<div class="container">
  <div [ngStyle]="{'display': deleteApiPop =='Y'? 'block' : 'none'}" style="overflow-y:auto"
       [ngClass]="{'modal': deleteApiPop == 'Y'}" class="modal" id="popupShippingLabel" tabindex="-1" role="dialog"
       aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Generate Invoice</h4>
          <button type="button" class="close" (click)="closePopup()">&times;</button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-6">
              <div id="statusText" class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText">
                {{statusText}}
              </div>
              <div class="form-group mb-md-0">
                <label class="control-label">Customer</label>
                <ng-select id="accountOwner" [(ngModel)]="accountOwner"
                           [ngModelOptions]="{standalone: true}" required
                           [items]="accountOwners"
                           bindLabel="ownerName"
                           bindValue="id"
                           [searchFn]="customSearchAccountOwner"
                           [searchWhileComposing]="true">
                  <ng-template ng-option-tmp let-item="item">
                    {{item?.ownerName}} <br/>
                    <small>{{item?.companyName}}</small>
                  </ng-template>
                </ng-select>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-delete" (click)="closePopup()">Cancel</button>
          <button type="button" class="btn btn-edit" (click)="generateInvoice()">Generate Invoice</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade right invoice" id="exampleModalPreview" tabindex="-1" role="dialog"
     aria-labelledby="exampleModalPreviewLabel" aria-hidden="true">
  <div class="modal-dialog snk-modal-dialog modal-fluid" role="document">
    <div class="snk-modal-content modal-content">
      <div class="snk-modal-header modal-header text-center">
        <h5 class="modal-title w-100" id="exampleModalPreviewLabel">Invoice</h5>
        <button type="button" class="close " data-dismiss="modal" aria-label="Close">
          <span style="font-size: 1.3em;" aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>
          <div class="row mt-3">
            <div class="col">
              <div class="inner-box" style="overflow:overlay">
                <div class="row">
                  <div class="col">
                    <div class="row">
                      <div class="col">
                        <div class="row mt-2">
                          <div class="col-md-6">
                            <address class="ml-2">
                              <strong>To:</strong><br>
                              <label><b></b><span
                                class="ml-1">{{invoiceData.companyName}}</span></label><br>
                              <label><b></b><span
                                class="ml-1">{{invoiceData.addressText}}</span></label><br>
                              <label><b></b><span
                                class="ml-1">{{invoiceData.ownerName}}</span></label><br>
                              <label><b></b><span class="ml-1">{{invoiceData.mobile}}
                                / {{invoiceData.email}}</span></label><br>
                            </address>
                          </div>
                          <div class="col-md-6">
                            <address>
                              <br>
                              <label><b>Invoice Number :</b><span class="ml-1">{{invoiceData.invoiceNum}}</span></label><br>
                              <label><b>Invoice Date :</b><span
                                class="ml-1">{{invoiceData.invoiceDate}}</span></label><br>
                              <label><b>Invoice Type :</b><span
                                class="ml-1">{{invoiceData.invoiceType | replaceStatus}}</span></label><br>
                              <label><b>Invoice Status :</b><span
                                class="ml-1">{{invoiceData.paymentStatus | replaceStatus}}</span></label><br>
                              <label><b>Reference Number :</b><span
                                class="ml-1">{{invoiceData.refNumber}}</span></label><br>
                              <label><b>Period :</b><span
                                class="ml-1">{{invoiceData.servicePeriod}}</span></label><br>
                            </address>
                          </div>
                        </div>
                        <div class="row mt-3">
                          <div class="col">
                            <table class="table" style="white-space:nowrap;">
                              <thead>
                              <tr>
                                <th>Line Number</th>
                                <th>Description</th>
                                <th>Amount</th>
                                <th>Reference Type</th>
                              </tr>
                              </thead>
                              <tbody>
                              <tr *ngFor="let inv of invoiceLinesVal">
                                <td>{{inv.invoiceLineNum}}</td>
                                <td>{{inv.itemCode | replaceStatus}}
                                </td>
                                <td>{{inv.invoiceAmount | number: '1.2-2'}}</td>
                                <td>{{inv.refType | replaceStatus}}
                                </td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                          </div>
                          <div class="col-6 deskContent" style="text-align:right;">
                            <label><b>Sub Total :</b><span
                              class="ml-1"> {{invoiceData.totalAmount | number: '1.2-2'}}  </span></label><br>
                            <div *ngIf="invoiceData.discountPrice > 0">
                              <label><b>Discount :</b><span
                                class="ml-1"> {{invoiceData.discountPrice | number: '1.2-2'}}</span></label><br>
                            </div>
                            <div class="mt-1" [hidden]="invoiceData.taxType !== 'IGST'">
                              <label><b>IGST (18%) :</b><span
                                class="ml-1"> {{invoiceData.taxableAmount | number: '1.2-2'}}</span></label>
                            </div>
                            <div class="mt-1" [hidden]="invoiceData.taxType != 'CGST, SGST'">
                              <label><b>CGST (9%) :</b><span
                                class="ml-1"> {{invoiceData.taxableAmount1  | number: '1.2-2'}}</span></label>
                            </div>
                            <div class="mt-1" [hidden]="invoiceData.taxType != 'CGST, SGST'">
                              <label><b>SGST (9%) :</b><span
                                class="ml-1"> {{invoiceData.taxableAmount2 | number: '1.2-2'}}</span></label><br>
                            </div>
                            <label><b>Total Amount :</b><span
                              class="ml-1"> {{invoiceData.calculatedTaxAmount  | number: '1.2-2'}}</span></label><br>
                            <label><b>In Words :</b><span class="ml-1">{{invoiceData.priceInWords}}
                              </span></label>
                          </div>
                          <div class="col-md-6 MobileContent" style="text-align:right;margin-left: 305px;">
                            <label style="white-space: nowrap;"><b>Sub Total :</b><span
                              class="ml-1"> {{invoiceData.totalAmount | number: '1.2-2'}}  </span></label><br>
                            <div *ngIf="invoiceData.discountPrice > 0">
                              <label style="white-space: nowrap;"><b>Discount :</b><span
                                class="ml-1"> {{invoiceData.discountPrice | number: '1.2-2'}}  </span></label><br>
                            </div>
                            <div class="mt-1" [hidden]="invoiceData.taxType !== 'IGST'">
                              <label style="white-space: nowrap;"><b>IGST (18%) :</b><span
                                class="ml-1"> {{invoiceData.taxableAmount | number: '1.2-2'}}</span></label>
                            </div>
                            <div class="mt-1" [hidden]="invoiceData.taxType != 'CGST, SGST'">
                              <label style="white-space: nowrap;"><b>CGST (9%) :</b><span
                                class="ml-1"> {{invoiceData.taxableAmount1  | number: '1.2-2'}}</span></label>
                            </div>
                            <div class="mt-1" [hidden]="invoiceData.taxType != 'CGST, SGST'">
                              <label style="white-space: nowrap;"><b>SGST (9%) :</b><span
                                class="ml-1"> {{invoiceData.taxableAmount2 | number: '1.2-2'}}</span></label><br>
                            </div>
                            <label><b>Total Amount :</b><span
                              class="ml-1"> {{invoiceData.calculatedTaxAmount  | number: '1.2-2'}}</span></label><br>
                            <label><b>In Words :</b><span class="ml-1">{{invoiceData.priceInWords}}
                              </span></label>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
